import Api from "../../api.service";
import Swal from "sweetalert2";
import store from "../";
const state = {
    dashNotifications: [],
    notificationCount: 0,

};
const getters = {
    dashNotifications(state) {
        return state.dashNotifications;
    },
    notificationCount(state) {
        return state.notificationCount;
    },
};
const mutations = {
    GET_DASH_ITEMS(state, payload) {
        state.dashNotifications = payload.dashNotifications;
        state.notificationCount = payload.notificationCount;
        store.dispatch("setLoading", false);
    },
    REMOVE_DASH_ITEM(state,payload)
    {
        state.dashNotifications.splice(payload, 1);
        Swal.fire({
            title: "تم الحذف !",
            text: `تم حذف الإشعار بنجاح .`,
            icon: "success",
            showConfirmButton: false,
            timer: 1500
        });
    },
    MARK_AS_READ(state)
    {
        state.dashNotifications.forEach(element => {
            element.isRead = true;
        });
        state.notificationCount= 0;
    }
};
const actions = {
    async fetchDashNotifications(context)
    {
        const {data} = await Api.query('/api/DashNotification/GetDashNotifications', {
            timeout: 3600000
        })
                                .then(data => data);
        context.commit('GET_DASH_ITEMS',data);
    },
    async setRead(context)
    {
         await Api.post('/api/DashNotification/SetRead');
        context.commit('MARK_AS_READ');
    },
    async removeDashNotification(context,payload)
    {
        const item = state.dashNotifications[payload];
        await Api.delete(`/api/DashNotification/RemoveDashNotification?id=${item.id}`);
        context.commit('REMOVE_DASH_ITEM',payload)
    }
}

const dash = { state, getters, mutations, actions };
export default dash;